var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMiniTerminal(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.513 1H2.084C1.485 1 1 1.485 1 2.084v32.512c0 .599.485 1.084 1.084 1.084h32.512c.599 0 1.084-.485 1.084-1.084V4.251 2.084c0-.599-.485-1.084-1.084-1.084h-1.083zm0 32.513H3.168V11.838h30.345v21.675zM15.61 23.117v2.047h-5.46v-2.047h5.46zm-8.7-8.871l3.923 4.094-3.924 4.094-1.535-1.585L7.85 18.34l-2.474-2.51 1.535-1.584zM33.512 3.167V9.67H3.168V3.168h30.345z",
    stroke: "#000",
    strokeWidth: 0.2,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C2243",
    d: "M20.387 5.375h2.047v2.047h-2.047zM24.481 5.375h2.047v2.047h-2.047zM29.258 5.375h2.047v2.047h-2.047z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniTerminal);
export default __webpack_public_path__ + "static/media/mini-terminal.181eec809c34a2c615dfec273e4dacca.svg";
export { ForwardRef as ReactComponent };